<template>
    <!-- Карточка пользователя в спике -->
    <div class="emc_card px-4 py-4 list-item-component">
        <div class="vx-row">
            <div
                class="vx-col w-full flex sm:items-center sm:flex-row flex-col"
            >
                <div class="lg:flex w-full lg:justify-between lg:items-center">
                    <div
                        style="width: 70%"
                        class="user_detail flex items-center justify-between cursor-pointer"
                        @click="openStudent(item.student.uid)"
                    >
                        <div class="user_name flex items-center">
                            <vs-avatar
                                v-if="item.student.avatar"
                                class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
                                :src="item.student.avatar"
                            />
                            <vs-avatar
                                v-else
                                class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
                                :text="avatarText"
                            ></vs-avatar>
                            <h5 class="todo-title mb-1">
                                {{ `${ item.student.last_name} ${ item.student.first_name } ${ item.student.middle_name }` }}<br>
                            </h5>
                        </div>
                        <div class="mobile_div"></div>
                        <vs-chip
                            v-if="statusText"
                            class="lg:ml-3"
                            transparent
                            :color="statusColor"
                        >{{ statusText }}</vs-chip>
                    </div>
                    <div class="user_date mail-item__meta flex items-center">
                        <!-- <span class="mr-2">{{$t('birthday')}}</span> -->
                        <vx-tooltip :text="$t('birthday')">
                            <div>{{ dateReplace }}</div>
                        </vx-tooltip>
                        <vx-tooltip :text="$t('reset_user')">
                            <vs-button
                                color="primary"
                                @click="openPopup()"
                                type="flat"
                                class="ml-0 lg:ml-3"
                                icon-pack="feather"
                                icon="icon-shield"
                            >
                            </vs-button>
                        </vx-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <vs-popup :title="$t('set_email')" :active.sync="activePrompt">
            <form>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input
                            class="w-full"
                            v-validate="'required|email'"
                            name="email"
                            :label="$t('email')"
                            v-model="email"
                        />
                        <span
                            class="text-danger text-sm"
                            v-show="errors.has('email')"
                        >{{errors.first('email') }}</span
                        >
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="roles.is_org_admin">
                    <div class="vx-col w-full">
                        <vs-checkbox v-model="restore_applicant">
                            {{ $t("ab_role") }}
                        </vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="restore_applicant">
                    <div class="vx-col w-full">
                        <multiselect
                            v-model="prep_level"
                            :options="prepLevelList"
                            v-validate="'required'"
                            name="prep_level"
                            :selectedLabel="$t('prep_levels')"
                            :placeholder="$t('prep_levels')"
                            @open="prepOpen()"
                            :loading="prepLoading"
                            @remove="prepRemove()"
                            deselectLabel=""
                            selectLabel=""
                            track-by="uid"
                        >
                            <template slot="singleLabel" slot-scope="props">
                                {{ props.option.name }}
                            </template>
                            <template slot="option" slot-scope="props">
                                {{ props.option.name }}
                            </template>
                            <div slot="noOptions">
                                {{ $t("no_data_text") }}
                            </div>
                        </multiselect>
                        <span
                            class="text-danger text-sm"
                            v-show="errors.has('prep_level')"
                        >{{ $t("validation_required") }}</span
                        >
                    </div>
                </div>
                <div class="vx-row mb-6" v-if="prep_level">
                    <div class="vx-col w-full">
                        <multiselect
                            v-model="campaign"
                            :options="campaignList"
                            :selectedLabel="$t('reception_type')"
                            :placeholder="$t('reception_type')"
                            @open="compainOpen()"
                            :loading="campaignLoading"
                            deselectLabel=""
                            selectLabel=""
                            track-by="uid"
                        >
                            <template slot="singleLabel" slot-scope="props">
                                {{ props.option.name }}
                            </template>
                            <template slot="option" slot-scope="props">
                                {{ props.option.name }}
                            </template>
                            <div slot="noOptions">
                                {{ $t("no_data_text") }}
                            </div>
                        </multiselect>
                    </div>
                </div>
                <vs-button color="primary" @click="resetUser()" type="filled">{{
                        $t("save")
                    }}</vs-button>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            activePrompt: false,
            email: "",
            restore_applicant: false,
            prep_level: null,
            campaign: null,
            prepLevelList: [],
            campaignList: [],
            prepLoading: false,
            campaignLoading: false,
        };
    },
    watch: {
        prep_level() {
            this.campaignList = [];
        },
    },
    computed: {
        roles(){
            return this.$store.state.user.roles;
        },
        user() {
            return this.$store.state.user.user;
        },
        userName() {
            // Если текущий язык английский, подставляем имя на англ
            if (this.$i18n.locale == "en") {
                // Если имя на англ пустое, используем рус имя
                if (this.user.first_name_en)
                    if (this.user.middle_name_en)
                        return `${this.user.last_name_en} ${this.user.first_name_en} ${this.user.middle_name_en}`;
                    else
                        return `${this.user.last_name_en} ${this.user.first_name_en}`;
                else
                if (this.user.middle_name_en)
                    return `${this.user.lastName} ${this.user.firstName} ${this.user.middle_name_en}`;
                else
                    return `${this.user.lastName} ${this.user.firstName}`;
            } else
                return `${this.user.lastName} ${this.user.firstName} ${this.user.middleName}`;
        },
        dateReplace() {
            // Меняем формат даты
            return this.$moment(this.item.student.birth_date).format(
                "DD-MM-YYYY"
            );
        },
        avatarText() {
            // Возвращяем инициалы пользователя
            let title,
                text = this.userName;
            const textAr = text.split(" ");
            if (textAr.length) {
                const newTitle = [];
                textAr.forEach((item) => {
                    newTitle.push(item.substr(0, 1).toUpperCase());
                });
                title = newTitle.join("");
            } else title = text.substr(0, 1);
            return title;
        },
        statusText(){
            // TODO: у екоторых может быть this.item.student.status == null
            // Подставляем локализацию для поля статус
            if(this.$i18n.locale == "ru"){
                return this.item.student.status.name;
            }
            if (this.$i18n.locale == "en"){
                if (this.item.student.status.name_en == null||this.item.student.status.name_en == ""){
                    return this.item.student.status.name;
                }else{
                    return this.item.student.status.name_en;
                }
            }
            if (this.$i18n.locale == "kk"){
                if (this.item.student.status.name_kk == null||this.item.student.status.name_kk == ""){
                    return this.item.student.status.name;
                }else{
                    return this.item.student.status.name_kk;
                }
            }
        },
        statusColor() {
            // Меняем цвет статуса пользователя
            switch (this.item.student.status.uid) {
                case "7de14e2f-31e2-11e9-aa40-0cc47a2bc1bf": // Задолжник
                    return "danger";
                    break;
                case "7de14e32-31e2-11e9-aa40-0cc47a2bc1bf": // 7de14e32-31e2-11e9-aa40-0cc47a2bc1bf
                    return "dark";
                    break;
                case "7de14e38-31e2-11e9-aa40-0cc47a2bc1bf": // Является магистром
                    return "success";
                    break;
                case "7de14e37-31e2-11e9-aa40-0cc47a2bc1bf": // Является магистрантом
                    return "success";
                    break;
                case "7de14e36-31e2-11e9-aa40-0cc47a2bc1bf": // Является доктором
                    return "danger";
                    break;
                case "7de14e35-31e2-11e9-aa40-0cc47a2bc1bf": // Является докторантом
                    return "danger";
                    break;
                case "7de14e34-31e2-11e9-aa40-0cc47a2bc1bf": // Является выпускником
                    return "#24c1a0";
                    break;
                default:
                    return "primary";
                    break;
            }
        },
    },
    methods: {
        prepRemove() {
            this.campaign = null;
        },
        async compainOpen() {
            try {
                this.campaignLoading = true;
                const { data } = await this.$http.post(
                    "/applicant/applicants/campaign-types/",
                    {
                        prep_level: this.prep_level.uid,
                    }
                );
                this.campaignList = data;
            } catch (e) {
                this.$vs.notify({
                    text: this.$t("error"),
                    color: "danger",
                });
            } finally {
                this.campaignLoading = false;
            }
        },
        async prepOpen() {
            if (!this.prepLevelList.length) {
                try {
                    this.prepLoading = true;
                    const { data } = await this.$http.get(
                        "/applicant/campaigns/open-prep-levels/"
                    );
                    this.prepLevelList = data;
                } catch (e) {
                    this.$vs.notify({
                        text: this.$t("error"),
                        color: "danger",
                    });
                } finally {
                    this.prepLoading = false;
                }
            }
        },
        openStudent() {
            // При нажатии на карточку студента, меняем страницу
            this.$router.push({
                path: "students-list/view",
                query: { uid: this.item.student.uid, full_name: this.item.student.full_name, student_id: this.item.student.student_id},
            });
        },
        openPopup() {
            this.activePrompt = true;
            this.email = this.item.student.email ? this.item.student.email : "";
        },
        resetUser() {
            // Проходим валидацию формы создания УМК
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        this.$vs.loading({
                            scale: 0.6,
                        });
                        let params = {
                            restore_applicant: this.restore_applicant,
                            email: this.email,
                            target: this.item.student.uid,
                        };

                        if (this.prep_level)
                            params.prep_level = this.prep_level.uid;
                        if (this.campaign) params.campaign = this.campaign.uid;

                        const { data } = await this.$http.get(
                            "/user/refresh/",
                            { params }
                        );
                        if (data === "ok") {
                            this.$vs.notify({
                                text: this.$t("email_restore_message", {
                                    mail: this.email,
                                }),
                                color: "success",
                            });

                            this.activePrompt = false;
                            this.prep_level = null;
                            this.campaign = null;
                            this.restore_applicant = false;
                        }
                    } catch (e) {
                        this.$vs.notify({
                            text: this.$t("error"),
                            color: "danger",
                        });
                    } finally {
                        this.$vs.loading.close();
                    }
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 900px) {
    .user_detail {
        flex-wrap: wrap;
        .sender__avatar {
            margin-left: 0px;
        }
        .user_name,
        .mobile_div {
            width: 100%;
        }
    }
    .user_date {
        margin-top: 5px;
    }
    .todo-title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
